import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios'


Vue.prototype.$axios = axios
Vue.use(ElementUI);

Vue.prototype.base_url = process.env.VUE_APP_URL
Vue.config.productionTip = false

// Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
